<device-admin>
  <div class="container mt-4">
    <!-- Page Header -->
    <page-header
      title={ state.deviceId ? 'Editar Dispositivo' : 'Crear Nuevo Dispositivo' }
      subtitle={ state.deviceId ? 'Modifica los datos del dispositivo existente' : 'Completa la información para crear un nuevo dispositivo' }
      onback={ handleBack }>
    </page-header>

    <!-- Loading state -->
    <loading-spinner
      if={ state.loading }
      message={ state.deviceId ? 'Cargando datos del dispositivo...' : 'Procesando...' } />

    <!-- Error state -->
    <error-alert
      if={ state.error }
      message={ state.errorMessage }
      onretry={ loadDevice } />

    <!-- Form -->
    <div if={ !state.loading && !state.error }>
      <form onsubmit={ handleSubmit }>
        <!-- Topic MQTT Configuration -->
        <div class="card mb-4">
          <div class="card-header">
            <h5 class="mb-0">Configuración del Topic MQTT</h5>
          </div>
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4">
                <div class="mb-3">
                  <label for="deviceApp" class="form-label">
                    <span class="badge bg-primary me-2">App</span>
                    Aplicación <span class="text-danger">*</span>
                  </label>
                  <input type="text" class="form-control { state.errors['app'] ? 'is-invalid' : '' }" id="deviceApp" name="app" value={ state.formData.app } onchange={ handleInputChange } placeholder="Ej: ac01">
                  <div class="invalid-feedback" if={ state.errors['app'] }>{ state.errors['app'] }</div>
                  <div class="form-text">Primera parte del topic MQTT</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-3">
                  <label for="deviceCity" class="form-label">
                    <span class="badge bg-success me-2">City</span>
                    Ciudad <span class="text-danger">*</span>
                  </label>
                  <input type="text" class="form-control { state.errors['city'] ? 'is-invalid' : '' }" id="deviceCity" name="city" value={ state.formData.city } onchange={ handleInputChange } placeholder="Ej: madrid">
                  <div class="invalid-feedback" if={ state.errors['city'] }>{ state.errors['city'] }</div>
                  <div class="form-text">Segunda parte del topic MQTT</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-3">
                  <label for="deviceName" class="form-label">
                    <span class="badge bg-info me-2">Name</span>
                    Nombre <span class="text-danger">*</span>
                  </label>
                  <input type="text" class="form-control { state.errors['name'] ? 'is-invalid' : '' }" id="deviceName" name="name" value={ state.formData.name } onchange={ handleInputChange } placeholder="Ej: puerta01">
                  <div class="invalid-feedback" if={ state.errors['name'] }>{ state.errors['name'] }</div>
                  <div class="form-text">Tercera parte del topic MQTT</div>
                </div>
              </div>
            </div>
            <div class="alert alert-info mb-3">
              <i class="bi bi-info-circle me-2"></i>
              <strong>Topic MQTT resultante:</strong>
              <code class="ms-2">{ state.formData.app || 'app' }/{ state.formData.city || 'city' }/{ state.formData.name || 'name' }</code>
            </div>
            <div class="alert alert-warning mb-0">
              <i class="bi bi-exclamation-triangle me-2"></i>
              Solo usar letras minúsculas, números y guiones. Sin espacios ni caracteres especiales.
            </div>
          </div>
        </div>

        <!-- Información adicional -->
        <div class="card mb-4">
          <div class="card-header">
            <h5 class="mb-0">Información Adicional</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <!-- Campo Usuario: SOLO VISIBLE PARA ADMINISTRADORES -->
              <div class="col-md-6" if={ isAdmin() }>
                <div class="mb-3">
                  <label for="deviceUser" class="form-label">Usuario Asignado <span class="text-danger">*</span></label>
                  <select
                    class="form-select { state.errors['user'] ? 'is-invalid' : '' }"
                    id="deviceUser"
                    name="user"
                    onchange={ handleInputChange }
                    disabled={ state.loadingUsers }>
                    <option value="">{ state.loadingUsers ? 'Cargando usuarios...' : '-- Seleccionar usuario --' }</option>
                    <option each={ user in state.users } value={ user._id } selected={ user._id === state.formData.user }>
                      { user.username } ({ user.email })
                    </option>
                  </select>
                  <div class="invalid-feedback" if={ state.errors['user'] }>{ state.errors['user'] }</div>
                  <div class="form-text">Selecciona el usuario al que se asignará el dispositivo</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="deviceTagid" class="form-label">Tag ID (NFC)</label>
                  <input type="text" class="form-control" id="deviceTagid" name="tagid" value={ state.formData.tagid } onchange={ handleInputChange }>
                  <div class="form-text">Identificador de la tarjeta NFC asociada</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Detalles técnicos -->
        <div class="card mb-4">
          <div class="card-header">
            <h5 class="mb-0">Detalles Técnicos</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="chipId" class="form-label">Chip ID</label>
                  <input type="text" class="form-control" id="chipId" name="details.chipId"
                         value={ state.formData.details.chipId } onchange={ handleInputChange }>
                  <div class="form-text">Identificador único del chip ESP</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="fwName" class="form-label">Nombre del Firmware</label>
                  <input type="text" class="form-control" id="fwName" name="details.fw_name"
                         value={ state.formData.details.fw_name } onchange={ handleInputChange }>
                  <div class="form-text">Nombre del firmware instalado</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="fwVersion" class="form-label">Versión del Firmware</label>
                  <input type="text" class="form-control" id="fwVersion" name="details.fw"
                         value={ state.formData.details.fw } onchange={ handleInputChange }>
                  <div class="form-text">Versión actual del firmware</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="deviceIp" class="form-label">Dirección IP</label>
                  <input type="text" class="form-control" id="deviceIp" name="details.ip"
                         value={ state.formData.details.ip } onchange={ handleInputChange }>
                  <div class="form-text">Dirección IP del dispositivo en la red</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="deviceRssi" class="form-label">RSSI</label>
                  <input type="number" class="form-control" id="deviceRssi" name="details.rssi"
                         value={ state.formData.details.rssi } onchange={ handleInputChange }>
                  <div class="form-text">Intensidad de señal WiFi (dBm)</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Canales -->
        <div class="card mb-4">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Canales</h5>
            <button type="button" class="btn btn-sm btn-outline-primary" onclick={ addChannel }>
              <i class="bi bi-plus-lg me-1"></i> Agregar Canal
            </button>
          </div>
          <div class="card-body">
            <div if={ state.formData.channels.length === 0 } class="text-muted text-center py-3">
              No hay canales configurados. Haz clic en "Agregar Canal" para añadir uno.
            </div>
            <div each={ (channel, index) in state.formData.channels } class="border rounded p-3 mb-3">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <h6 class="mb-0">Canal { index + 1 }</h6>
                <button type="button" class="btn btn-sm btn-outline-danger" onclick={ () => removeChannel(index) }>
                  <i class="bi bi-trash"></i>
                </button>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">Nombre del Canal <span class="text-danger">*</span></label>
                    <input type="text" class="form-control { state.errors['channel.' + index + '.name'] ? 'is-invalid' : '' }" value={ channel.name } onchange={ (e) => updateChannel(index, 'name', e.target.value) }>
                    <div class="invalid-feedback" if={ state.errors['channel.' + index + '.name'] }>{ state.errors['channel.' + index + '.name'] }</div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">ID del Canal <span class="text-danger">*</span></label>
                    <select class="form-select { state.errors['channel.' + index + '.channel'] ? 'is-invalid' : '' }" value={ channel.channel } onchange={ (e) => updateChannel(index, 'channel', e.target.value) }>
                      <option value="">-- Seleccionar --</option>
                      <option value="in0">in0 (Entrada 0)</option>
                      <option value="in1">in1 (Entrada 1)</option>
                      <option value="out0">out0 (Salida 0)</option>
                      <option value="out1">out1 (Salida 1)</option>
                    </select>
                    <div class="invalid-feedback" if={ state.errors['channel.' + index + '.channel'] }>{ state.errors['channel.' + index + '.channel'] }</div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">Estado Inicial</label>
                    <select class="form-select" value={ channel.lastState || 'NONE' } onchange={ (e) => updateChannel(index, 'lastState', e.target.value) }>
                      <option value="NONE">NONE</option>
                      <option value="ON">ON</option>
                      <option value="OFF">OFF</option>
                      <option value="PULSE">PULSE</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Configuración RFID -->
        <div class="card mb-4">
          <div class="card-header">
            <h5 class="mb-0">
              <i class="bi bi-credit-card me-2"></i>
              Configuración de Lector RFID
            </h5>
          </div>
          <div class="card-body">
            <!-- Switch para habilitar RFID -->
            <div class="form-check form-switch mb-4">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                id="rfidEnabled"
                name="rfidConfig.enabled"
                checked={ state.formData.rfidConfig.enabled }
                onchange={ handleRfidEnabledChange }>
              <label class="form-check-label" for="rfidEnabled">
                <strong>Habilitar lector RFID</strong>
              </label>
              <div class="form-text">
                Activa esta opción si el dispositivo tiene un lector RFID/iButton instalado
              </div>
            </div>

            <!-- Configuración adicional (solo si RFID está habilitado) -->
            <div if={ state.formData.rfidConfig.enabled } class="border-top pt-3">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="rfidDefaultChannel" class="form-label">
                      Canal de Salida por Defecto <span class="text-danger">*</span>
                    </label>
                    <select
                      class="form-select { state.errors['rfidConfig.defaultChannel'] ? 'is-invalid' : '' }"
                      id="rfidDefaultChannel"
                      name="rfidConfig.defaultChannel"
                      value={ state.formData.rfidConfig.defaultChannel }
                      onchange={ handleRfidConfigChange }>
                      <option value="">-- Seleccionar Canal --</option>
                      <option value="out0">out0 (Salida 0)</option>
                      <option value="out1">out1 (Salida 1)</option>
                      <option value="out2">out2 (Salida 2)</option>
                      <option value="out3">out3 (Salida 3)</option>
                    </select>
                    <div class="invalid-feedback" if={ state.errors['rfidConfig.defaultChannel'] }>{ state.errors['rfidConfig.defaultChannel'] }</div>
                    <div class="form-text">
                      Canal que se activará cuando se valide una tarjeta RFID
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Modo de Activación</label>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="rfidConfig.pulseMode"
                        id="pulseModeTrue"
                        value="true"
                        checked={ state.formData.rfidConfig.pulseMode === true }
                        onchange={ () => handleRfidPulseModeChange(true) }>
                      <label class="form-check-label" for="pulseModeTrue">
                        <strong>PULSE</strong> - Activación temporal (recomendado)
                      </label>
                      <div class="form-text ms-4">
                        El canal se activa por un breve periodo y luego se desactiva automáticamente
                      </div>
                    </div>
                    <div class="form-check mt-2">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="rfidConfig.pulseMode"
                        id="pulseModefalse"
                        value="false"
                        checked={ state.formData.rfidConfig.pulseMode === false }
                        onchange={ () => handleRfidPulseModeChange(false) }>
                      <label class="form-check-label" for="pulseModefalse">
                        <strong>ON</strong> - Activación permanente
                      </label>
                      <div class="form-text ms-4">
                        El canal permanece activo hasta que se envíe un comando OFF
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="alert alert-info mb-0">
                <i class="bi bi-info-circle me-2"></i>
                <strong>Funcionamiento:</strong> Cuando un usuario presenta una tarjeta RFID válida,
                el sistema validará la tarjeta con el servidor y, si está autorizada,
                enviará un comando <code>{ state.formData.rfidConfig.pulseMode ? 'PULSE' : 'ON' }</code>
                al canal <code>{ state.formData.rfidConfig.defaultChannel || 'no seleccionado' }</code>.
              </div>
            </div>
          </div>
        </div>

        <!-- Botones de acción -->
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-end gap-2">
              <button type="button" class="btn btn-outline-secondary app-btn app-btn-md" onclick={ handleBack }>
                Cancelar
              </button>
              <button type="submit" class="btn btn-primary app-btn app-btn-md" disabled={ state.saving }>
                <span if={ state.saving } class="spinner-border spinner-border-sm me-2" role="status"></span>
                { state.deviceId ? 'Actualizar Dispositivo' : 'Crear Dispositivo' }
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <script>
    import PageHeader from './page-header.riot'
    import LoadingSpinner from './loading-spinner.riot'
    import ErrorAlert from './error-alert.riot'
    import { DeviceService, AuthService, UserService } from '../services/api-service'
    import { ToastService } from '../services/toast-service'

    export default {
      components: {
        PageHeader,
        LoadingSpinner,
        ErrorAlert
      },
      onBeforeMount() {
        // Obtener el ID del dispositivo desde la URL si existe
        const urlParams = new URLSearchParams(window.location.search)
        const deviceId = urlParams.get('id')

        this.state = {
          deviceId: deviceId,
          loading: !!deviceId, // Solo cargar si hay ID (modo edición)
          error: false,
          errorMessage: '',
          saving: false,
          errors: {},
          formData: this.getInitialFormData(),
          users: [],
          loadingUsers: false
        }
      },

      async onMounted() {
        // Verificar permisos de administrador
        if (!AuthService.isAdmin()) {
          this.update({
            error: true,
            errorMessage: 'Acceso denegado. Debes ser administrador para acceder a esta sección.'
          })
          return
        }

        // Cargar la lista de usuarios
        await this.loadUsers()

        // Si hay deviceId, cargar los datos del dispositivo
        if (this.state.deviceId) {
          await this.loadDevice()
        }
      },

      async loadUsers() {
        try {
          this.update({ loadingUsers: true })
          const users = await UserService.getUsers()
          this.update({
            users,
            loadingUsers: false
          })
        } catch (error) {
          console.error('Error loading users:', error)
          ToastService.error('Error al cargar la lista de usuarios')
          this.update({ loadingUsers: false })
        }
      },

      getInitialFormData() {
        return {
          name: '',
          tagid: '',
          city: '',
          app: '',
          user: '',
          details: {
            chipId: '',
            fw_name: '',
            fw: '',
            ip: '',
            rssi: ''
          },
          channels: [],
          rfidConfig: {
            enabled: false,
            defaultChannel: 'out0',
            pulseMode: true
          }
        }
      },

      async loadDevice() {
        if (!this.state.deviceId) return

        try {
          this.update({ loading: true, error: false })

          const device = await DeviceService.getDeviceById(this.state.deviceId)

          // Mapear los datos del dispositivo al formulario
          const userId = typeof device.user === 'object' ? device.user._id : (device.user || '')

          this.update({
            formData: {
              name: device.name || '',
              tagid: device.tagid || '',
              city: device.city || '',
              app: device.app || '',
              user: userId,
              details: {
                chipId: device.details?.chipId || '',
                fw_name: device.details?.fw_name || '',
                fw: device.details?.fw || '',
                ip: device.details?.ip || '',
                rssi: device.details?.rssi || ''
              },
              channels: device.channels?.map(ch => ({
                name: ch.name,
                channel: ch.channel,
                lastState: ch.lastState || 'NONE'
              })) || [],
              rfidConfig: {
                enabled: device.rfidConfig?.enabled || false,
                defaultChannel: device.rfidConfig?.defaultChannel || 'out0',
                pulseMode: device.rfidConfig?.pulseMode !== false // default true
              }
            },
            loading: false
          })
        } catch (error) {
          console.error('Error loading device:', error)
          this.update({
            loading: false,
            error: true,
            errorMessage: `Error al cargar el dispositivo: ${error.message || 'Error desconocido'}`
          })
        }
      },

      handleInputChange(e) {
        const { name, value } = e.target
        const errors = this.clearError(name)

        if (name.includes('.')) {
          // Manejar campos anidados como details.chipId
          const [parent, child] = name.split('.')
          this.update({
            errors,
            formData: {
              ...this.state.formData,
              [parent]: {
                ...this.state.formData[parent],
                [child]: value
              }
            }
          })
        } else {
          // Manejar campos de primer nivel
          this.update({
            errors,
            formData: {
              ...this.state.formData,
              [name]: value
            }
          })
        }
      },

      // Devuelve una copia de los errores sin el campo indicado, para que la
      // marca de error desaparezca apenas el usuario corrige el dato
      clearError(name) {
        if (!this.state.errors || !this.state.errors[name]) {
          return this.state.errors
        }

        const errors = { ...this.state.errors }
        delete errors[name]
        return errors
      },

      // Métodos para manejar canales
      addChannel() {
        const newChannel = {
          name: '',
          channel: '',
          lastState: 'NONE'
        }
        this.update({
          formData: {
            ...this.state.formData,
            channels: [...this.state.formData.channels, newChannel]
          }
        })
      },

      removeChannel(index) {
        const channels = [...this.state.formData.channels]
        channels.splice(index, 1)
        this.update({
          formData: {
            ...this.state.formData,
            channels
          }
        })
      },

      updateChannel(index, field, value) {
        const channels = [...this.state.formData.channels]
        channels[index] = {
          ...channels[index],
          [field]: value
        }
        this.update({
          errors: this.clearError(`channel.${index}.${field}`),
          formData: {
            ...this.state.formData,
            channels
          }
        })
      },

      // Métodos para manejar configuración RFID
      handleRfidEnabledChange(e) {
        this.update({
          formData: {
            ...this.state.formData,
            rfidConfig: {
              ...this.state.formData.rfidConfig,
              enabled: e.target.checked
            }
          }
        })
      },

      handleRfidConfigChange(e) {
        const { name, value } = e.target
        const field = name.split('.')[1] // Extrae 'defaultChannel' de 'rfidConfig.defaultChannel'

        this.update({
          errors: this.clearError(name),
          formData: {
            ...this.state.formData,
            rfidConfig: {
              ...this.state.formData.rfidConfig,
              [field]: value
            }
          }
        })
      },

      handleRfidPulseModeChange(value) {
        this.update({
          formData: {
            ...this.state.formData,
            rfidConfig: {
              ...this.state.formData.rfidConfig,
              pulseMode: value
            }
          }
        })
      },

      // Solo letras minúsculas, números y guiones (espejo de la advertencia del topic MQTT)
      isValidTopicPart(value) {
        return /^[a-z0-9-]+$/.test(value)
      },

      validateForm() {
        const { app, city, name, user, channels, rfidConfig } = this.state.formData
        const errors = {}

        // Topic MQTT: app / city / name
        if (!app.trim()) {
          errors.app = 'La aplicación es requerida'
        } else if (!this.isValidTopicPart(app.trim())) {
          errors.app = 'Solo letras minúsculas, números y guiones'
        }

        if (!city.trim()) {
          errors.city = 'La ciudad es requerida'
        } else if (!this.isValidTopicPart(city.trim())) {
          errors.city = 'Solo letras minúsculas, números y guiones'
        }

        if (!name.trim()) {
          errors.name = 'El nombre es requerido'
        } else if (!this.isValidTopicPart(name.trim())) {
          errors.name = 'Solo letras minúsculas, números y guiones'
        }

        // Usuario asignado: obligatorio para administradores
        if (this.isAdmin() && !user) {
          errors.user = 'Debes asignar un usuario al dispositivo'
        }

        // Canales: si hay canales, nombre e ID son obligatorios
        channels.forEach((channel, index) => {
          if (!channel.name || !channel.name.trim()) {
            errors[`channel.${index}.name`] = 'El nombre del canal es requerido'
          }
          if (!channel.channel) {
            errors[`channel.${index}.channel`] = 'Debes seleccionar el ID del canal'
          }
        })

        // RFID: canal por defecto obligatorio cuando está habilitado
        if (rfidConfig.enabled && !rfidConfig.defaultChannel) {
          errors['rfidConfig.defaultChannel'] = 'Debes seleccionar el canal de salida por defecto'
        }

        this.update({ errors })

        if (Object.keys(errors).length > 0) {
          ToastService.error('Revisá los campos marcados en rojo')
          return false
        }

        return true
      },

      async handleSubmit(e) {
        e.preventDefault()

        if (this.state.saving) return

        if (!this.validateForm()) {
          return
        }

        try {
          this.update({ saving: true })

          // Preparar los datos para enviar
          const deviceData = {
            name: this.state.formData.name,
            city: this.state.formData.city,
            app: this.state.formData.app,
            user: this.state.formData.user,
            tagid: this.state.formData.tagid || undefined
          }

          // Agregar detalles si hay datos
          const details = this.state.formData.details
          if (details.chipId || details.fw_name || details.fw || details.ip || details.rssi) {
            deviceData.details = {}
            if (details.chipId) deviceData.details.chipId = details.chipId
            if (details.fw_name) deviceData.details.fw_name = details.fw_name
            if (details.fw) deviceData.details.fw = details.fw
            if (details.ip) deviceData.details.ip = details.ip
            if (details.rssi) deviceData.details.rssi = parseInt(details.rssi) || undefined
          }

          // Agregar canales si hay
          if (this.state.formData.channels.length > 0) {
            deviceData.channels = this.state.formData.channels.filter(ch => ch.name && ch.channel)
          }

          // Agregar configuración RFID
          deviceData.rfidConfig = {
            enabled: this.state.formData.rfidConfig.enabled,
            defaultChannel: this.state.formData.rfidConfig.defaultChannel,
            pulseMode: this.state.formData.rfidConfig.pulseMode
          }

          let result
          if (this.state.deviceId) {
            // Actualizar dispositivo existente
            result = await DeviceService.updateDevice(this.state.deviceId, deviceData)
            ToastService.success('Dispositivo actualizado correctamente')
          } else {
            // Crear nuevo dispositivo
            result = await DeviceService.createDevice(deviceData)
            ToastService.success('Dispositivo creado correctamente')
          }

          // Redirigir después del éxito
          this.handleBack()

        } catch (error) {
          console.error('Error saving device:', error)
          ToastService.error(`Error al ${this.state.deviceId ? 'actualizar' : 'crear'} el dispositivo: ${error.message || 'Error desconocido'}`)
        } finally {
          this.update({ saving: false })
        }
      },

      handleBack() {
        // Volver a la página anterior o a la lista de dispositivos
        if (this.props.onback) {
          this.props.onback()
        } else {
          window.history.back()
        }
      },

      isAdmin() {
        return AuthService.isAdmin()
      }
    }
  </script>
</device-admin>
